<img class="loader-container" src="/assets/logo.gif">